import * as fromDatatype from '../datatype-library/index';

export interface app_password_policy_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.VarcharDatatypeInterface;
  max_password_age: fromDatatype.TextDatatypeInterface;
  policy_start_date: fromDatatype.TimestampTzDatatypeInterface;
  policy_end_date: fromDatatype.TimestampTzDatatypeInterface;
  min_password_length: fromDatatype.IntegerDatatypeInterface;   //data type is long
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_password_policy_line_RowClass implements app_password_policy_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.VarcharDatatypeInterface;
  max_password_age: fromDatatype.TextDatatypeInterface;
  policy_start_date: fromDatatype.TimestampTzDatatypeInterface;
  policy_end_date: fromDatatype.TimestampTzDatatypeInterface;
  min_password_length: fromDatatype.IntegerDatatypeInterface;   //data type is long
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


